document.addEventListener("DOMContentLoaded", function () {
	const sliders = $(".portfolio__slider");
	if (!sliders.length) return;

	const mobileBreakpoint = 1024;
	let slickStates = [];

	sliders.each(function (index) {
		slickStates[index] = false;
	});

	function initMobileSliders() {
		sliders.each(function (index) {
			const $slider = $(this);
			if (window.innerWidth < mobileBreakpoint && !slickStates[index]) {
				$slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					infinite: true,
					speed: 400,
					prevArrow: $slider
						.closest(".portfolio")
						.find(".portfolio__prev-" + index),
					nextArrow: $slider
						.closest(".portfolio")
						.find(".portfolio__next-" + index),
					swipe: true,
					touchMove: true,
				});
				slickStates[index] = true;
			} else if (
				window.innerWidth >= mobileBreakpoint &&
				slickStates[index]
			) {
				$slider.slick("unslick");
				slickStates[index] = false;
			}
		});
	}

	initMobileSliders();
	window.addEventListener("resize", initMobileSliders);
});
